<template>
  <BModal
    v-model="isVisible"
    modal-class="zoomIn"
    hide-footer
    no-close-on-backdrop
    centered
    title="Confirmer la suppression"
    @hidden="onClose"
  >
    <div class="mt-2 text-center">
      <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
        <h4>Êtes-vous sûr ?</h4>
        <p class="text-muted mx-4 mb-0">
          Voulez-vous vraiment supprimer cette entreprise ? Cette action est
          irréversible.
        </p>
      </div>
    </div>
    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
      <BButton variant="light" @click="handleCancel" :disabled="deleting"
        >Annuler</BButton
      >
      <BButton variant="danger" @click="handleConfirm" :disabled="deleting">
        <span
          v-if="deleting"
          class="spinner-border spinner-border-sm me-1"
        ></span>
        {{ deleting ? 'Suppression...' : 'Oui, Supprimer' }}
      </BButton>
    </div>
  </BModal>
</template>

<script>
import { companyService } from '@/shared/services/company.service';
import notificationService from '@/shared/services/notification.service';

export default {
  name: 'DeleteCompanyModal',
  props: {
    modelValue: { type: Boolean, default: false },
    company: { type: Object, default: null },
  },
  emits: ['update:modelValue', 'deleted'],
  data() {
    return { deleting: false };
  },
  computed: {
    isVisible: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      },
    },
  },
  methods: {
    handleCancel() {
      this.isVisible = false;
    },
    onClose() {
      this.$emit('update:modelValue', false);
    },
    async handleConfirm() {
      if (!this.company?.id) return;
      this.deleting = true;
      try {
        await companyService.deleteCompany(this.company.id);
        this.isVisible = false;
        notificationService.successAction('delete', 'company');
        this.$emit('deleted', this.company.id);
      } catch (err) {
        console.error(err);
        notificationService.errorAction(
          'delete',
          'company',
          err.response?.data?.message || 'Erreur lors de la suppression.',
        );
      } finally {
        this.deleting = false;
      }
    },
  },
};
</script>
